angular.module("ainapp")
    .controller("ResignationFormController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "Resignation Forms";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.ResignationForm = {
                    EmployeeId: $scope.TokenInfo.EmployeeId,
                    ResignationDate: "",
                    Reason: "",
                    Remarks: "",
                }

            }
            $scope.Init();





            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.EmployeeId = $scope.TokenInfo.EmployeeId;
                        MainService.ResignationFormsInGrid(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },

                            ResignationDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Reason: {
                                type: "string",
                                editable: false,
                            },

                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Date",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "ResignationDate",
                        title: "ResignationDate",
                        headerTemplate: "{{LanguageData.ResignationDate}}",
                        template: "#= kendo.toString(kendo.parseDate(ResignationDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Reason",
                        title: "Reason",
                        headerTemplate: "{{LanguageData.Reason}}",
                        },
                    {
                        field: "Status",
                        title: "Status",
                        headerTemplate: "{{LanguageData.Status}}",

                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        headerTemplate: "{{LanguageData.Remarks}}",
                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };



            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {


                    if (data.Status == 'New') {
                        $scope.SelectedDataForDelete = data;
                        $("#deleteModal").modal("show");
                    } else {
                        toastr.info($scope.LanguageData.CannotDeleteWhileInProcess);
                    }

                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteResignationForm($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {

                if (data.Status == 'New') {
                    $scope.ResignationForm = data;
                } else {
                    toastr.info($scope.LanguageData.CannotEditWhileInProcess);
                }

            }


            $scope.SaveData = function () {
                if (!$scope.TokenInfo.IsAdd && !$scope.ResignationForm.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.TokenInfo.IsEdit && $scope.ResignationForm.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                }
                //                else if ($scope.ResignationForm.EmployeeId == "") {
                //                    toastr.warning("Select Employee");
                //
                //
                //                } 
                else if ($scope.ResignationForm.ResignationDate == "") {
                    toastr.warning($scope.LanguageData.EnterResignationDate);

                } else if ($scope.ResignationForm.Reason == "") {
                    toastr.warning($scope.LanguageData.EnterReason);

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveResignationForm($scope.ResignationForm).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }



                }]);
